import * as Yup from 'yup';

const addressPrePlanInspectionSchema = Yup.object({
  ptsPersonID: Yup.number().nullable().required('Person is required'),
  ShiftDesignation: Yup.string().nullable().required('Shift Designation is required'),
});

export default addressPrePlanInspectionSchema;
